import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AvayaCallData from "./ViewModels/AvayaCallData";

interface IAvayaCallDataDisplayProps {
    avayaCallData: AvayaCallData
}

export default function AvayaCallDataDisplay({ avayaCallData }: IAvayaCallDataDisplayProps) {
    const fullLineText = (text: string) => {
        return <Grid size={12}>
            <Typography>{text}</Typography>
        </Grid>
    }

    return (
        <Grid container padding={1}>
            <>
                {
                    avayaCallData.phoneNumber &&
                    fullLineText(`Phone number: ${avayaCallData.phoneNumber}`)
                }
            </>
            <>
                {
                    avayaCallData.time &&
                    fullLineText(`Time: ${avayaCallData.time}`)

                }
            </>
            <>
                {
                    avayaCallData.result &&
                    fullLineText(`Result: ${avayaCallData.result}`)

                }
            </>
        </Grid>
    );
};
